/**
 * Наименование таблицы (модели) из файла i18n
 */
export const TABLE_NAME = 'report-access-settings-users';
